"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

var _send = require("@/api/cms/send");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'AuditPanel',
  props: {
    auditOpinion: {
      type: String,
      default: ''
    },
    sendTaskId: {
      type: [String, Number],
      default: null
    },
    deliveryNo: {
      type: String,
      default: ''
    },
    contractList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      auditing: false
    };
  },
  methods: {
    handleReject: function handleReject() {
      var _this = this;

      if (!this.auditOpinion || !this.auditOpinion.trim()) {
        this.$message.warning('请填写您的审批意见');
        return;
      }

      this.$confirm('确定驳回该发货单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.doAudit(1011);
      }).catch(function () {});
    },
    handleApprove: function handleApprove() {
      var _this2 = this;

      this.$confirm('确定同意该发货单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.doAudit(1010);
      }).catch(function () {});
    },
    doAudit: function doAudit(status) {
      var _this3 = this;

      this.auditing = true;
      var contractNumber = this.contractList && this.contractList.length > 0 ? this.contractList[0].contractNumber || this.contractList[0].contractNo || this.contractList[0].custContractNo || '' : '';
      (0, _send.addSendTaskLog)({
        sendTaskId: this.sendTaskId,
        sendNumber: this.deliveryNo || '',
        contractNumber: contractNumber,
        step: String(status),
        remark: this.auditOpinion || ''
      }).then(function () {
        _this3.$message.success(status === 1011 ? '已驳回' : '已同意');

        _this3.$emit('audit-done');
      }).catch(function (error) {
        console.error('审核操作失败:', error);

        _this3.$message.error('操作失败，请重试');
      }).finally(function () {
        _this3.auditing = false;
      });
    }
  }
};
exports.default = _default2;